module.exports = __webpack_public_path__ + "media/assets/images/tour/4b_Tour_5-5f467ac3f0d26d04df4bcc2d2537f52a.png";